import React from 'react';
import BottomSheetContainer from "@sharedComponents/Bottomsheet/Bottomsheet";
import {ThemedText, ThemedView} from '@app/theme';
import Button from "@sharedComponents/Button/Button";
import SystemErrorIcon from "../../../../assets/Icons/SystemErrorIcon";

interface ErrorCardProps {
    visible: boolean;
    onClose: () => void;
    failedMessage?: string;
    colors: any;
}

const ErrorCard: React.FC<ErrorCardProps> = ({ visible, onClose, colors, failedMessage }) => (
    <BottomSheetContainer
        isVisible={visible}
        close={onClose}
        onClose={onClose}
        dragComponent={undefined}
        closeOnBackdropPress={true}
        borderTopRightRadius={10}
        borderTopLeftRadius={10}

        containerStyle={{backgroundColor: '#fefefe'}}
    >
        <ThemedView alignItems={"center"} padding={"lg"}>
            <SystemErrorIcon/>
            <ThemedText mt={"2xl"} variant={"h5s"} mb={"sm"}>
                {"Verification failed"}
            </ThemedText>
            <ThemedView borderRadius={"sm"} padding={"md"} backgroundColor={"bg-fill-warning"} style={{width: "100%"}} mb={"2xl"}>
                <ThemedText variant={"b3r"} textAlign={"center"}>
                    {failedMessage}
                </ThemedText>
            </ThemedView>
            <Button
                label="Try again"
                type="OUTLINED"
                size='MD'
                disabled={false}
                handlePress={onClose}
                bg={'bg-action-primary'}
                textColor={colors['text-primary']}
            />
        </ThemedView>
    </BottomSheetContainer>
);

export default ErrorCard;